import React, { useEffect } from "react";
import styled from "styled-components";
import { RoundButton } from "../../components/common";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/ModalSlice";
import { MODAL_PAYLOAD } from "../../constants";
import moment from "moment";
//push

const NoContents = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const bannerManual = () => {
        navigate("/tutorial");
    };

    return (
        <NoContentsWrap>
            <p>배너 그룹을 선택해주세요</p>
            {/* <RoundButton onClick={bannerManual}>
                배너 관리 앱 사용법
            </RoundButton> */}
        </NoContentsWrap>
    );
};

const NoContentsWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 24px;

    p {
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: var(--gray-700);
    }
`;
export default NoContents;
